import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { ChecklistName, NotificationMessage } from '~/shared/types/notification.types'

export default function ChecklistNotification({ message }: { message: NotificationMessage }): React.ReactElement {
  const { t } = useTranslation('dashboard')
  const isChecklistItem = message.item_name ? message.item_name.startsWith(ChecklistName.CHECKLIST) : false
  const checklistItemKey = message.item_name
    ? isChecklistItem
      ? message.item_name.split('#')[1]
      : message.item_name.split('#')[0]
    : ''

  return (
    <>
      <div className="flex items-center pt-1">
        <ResponsiveImage
          alt={t('checklists.checklists.checklistItem')}
          className="min-w-max px-5"
          height={56}
          imageWidths="56"
          srcKey="icons/checklist-rocket.png"
          width={56}
        />
        <div className="pr-2 text-left">
          <h3 className="font-semibold text-md uppercase">{`${t('checklists.title')}!`}</h3>
          <p className="text-sm">{t(`checklists.notification.${checklistItemKey}`)}</p>
        </div>
      </div>
    </>
  )
}
